import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {AuthenticationMethodType} from "@vesta/vos-types/modules/platformLevel/authentication/domain/AuthenticationMethodType";
import {z as zod} from "zod";

export {AuthenticationMethodType};

export const authenticationMethodTypeLabel: Record<AuthenticationMethodType, string> = {
    [AuthenticationMethodType.impersonate]: "Impersonate",
    [AuthenticationMethodType.otpViaEmail]: "OTP via Email",
    [AuthenticationMethodType.otpViaSms]: "OTP via SMS",
    [AuthenticationMethodType.passwordViaEmail]: "Password via Email",
    [AuthenticationMethodType.ssoViaGoogle]: "SSO via Google",
    [AuthenticationMethodType.ssoViaMicrosoft]: "SSO via Microsoft",
};

export type AuthenticationUser = {
    id: Uuid;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
};

export type AuthenticationUserRow = AuthenticationUser & {
    name: string | null;
    email: string | null;
    phoneNumber: string | null;
};

export const authenticationUserValidator = zod.object({
    id: uuidZodValidator,
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
});
